import { Link } from 'react-router-dom'
import styles from './Tile.module.css'

interface Props {
  label: string
  value: string
  note?: string | undefined
  tone?: 'up' | 'down' | undefined
  loading?: boolean | undefined
  /** Куда ведёт плитка. Без него — обычный блок без ссылки. */
  to?: string | undefined
}

/**
 * Плитка сводки: подпись, крупное число, комментарий под ним.
 *
 * Пока данные едут — заглушка ровно той же высоты, а не «—» и не
 * ноль. Ноль в плитке «Всего средств» человек читает как «баланс
 * обнулился» и в ту же секунду идёт проверять, куда делись деньги.
 */
export function Tile({ label, value, note, tone, loading, to }: Props) {
  if (loading) return <div className={styles.skeleton} />

  const body = (
    <>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {note ? (
        <span className={tone ? `${styles.note} ${styles[tone]}` : styles.note}>{note}</span>
      ) : null}
    </>
  )

  // Ссылкой, а не кнопкой с navigate: плитку открывают в новой вкладке
  // средним кликом, чтобы не терять из виду обзор.
  if (to) {
    return <Link className={`${styles.tile} ${styles.clickable}`} to={to}>{body}</Link>
  }
  return <div className={styles.tile}>{body}</div>
}

/** Куда смотрит изменение: вверх зелёным, вниз красным, ноль — никак. */
export function toneOf(value: string | number): 'up' | 'down' | undefined {
  const number = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(number) || number === 0) return undefined
  return number > 0 ? 'up' : 'down'
}
